/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import ColorPicker from 'shared/ui/components/form-components/pickers/ColorPicker.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const __vue_script__ = {
    name: 'SimplifiedColorsForm',

    components: {
        Badge,
        Checkbox,
        ColorPicker,
        Toggler
    },

    props: {
        theme: {
            type: Object,
            required: true
        },

        appearance: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            color2: this.theme.color2,
            color4: this.theme.color4,
            color12: this.theme.color12,
            color13: this.theme.color13 || this.theme.color1,
            tintIcons: this.theme.tintIcons
        };
    },

    created() {
        if (this.theme.color1 !== this.theme.color13) {
            this.emit();
        }
    },

    methods: {
        emit() {
            this.$emit('change', {
                color1: this.color13,
                color2: this.color2,
                color4: this.color4,
                color12: this.color12,
                color13: this.color13,
                color5: this.color13,
                tintIcons: this.tintIcons
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "simplified-colors-form theme-elements" },
    [
      _c("validation-provider", {
        attrs: { rules: "hex_color|required", slim: true, name: "color13" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("color-picker", {
                  attrs: {
                    name: "color13",
                    label: _vm.$t("theme.editor.colours.primary_bg"),
                    tip: _vm.$t("theme.editor.colours.header_bg_tip"),
                    errors: errors,
                  },
                  on: { input: _vm.emit },
                  model: {
                    value: _vm.color13,
                    callback: function ($$v) {
                      _vm.color13 = $$v
                    },
                    expression: "color13",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("validation-provider", {
        attrs: { rules: "hex_color|required", slim: true, name: "color2" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("color-picker", {
                  attrs: {
                    name: "color2",
                    label: _vm.$t("theme.editor.colours.header_fg"),
                    tip: _vm.$t("theme.editor.colours.header_fg_tip"),
                    errors: errors,
                  },
                  on: { input: _vm.emit },
                  model: {
                    value: _vm.color2,
                    callback: function ($$v) {
                      _vm.color2 = $$v
                    },
                    expression: "color2",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("validation-provider", {
        attrs: { slim: true, name: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("toggler", {
                  staticClass: "no-main-label",
                  attrs: {
                    errors: errors,
                    "on-label": "theme.editor.colours.enable_icons_tint",
                    "off-label": "theme.editor.colours.enable_icons_tint",
                    hint: _vm.$t("theme.editor.colours.enable_icons_tint_hint"),
                    name: "enableTing",
                  },
                  on: { input: _vm.emit },
                  model: {
                    value: _vm.tintIcons,
                    callback: function ($$v) {
                      _vm.tintIcons = $$v
                    },
                    expression: "tintIcons",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("validation-provider", {
        attrs: { rules: "hex_color|required", slim: true, name: "color4" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("color-picker", {
                  attrs: {
                    name: "color4",
                    label: _vm.$t("theme.editor.colours.menu_icons"),
                    disabled: !_vm.tintIcons,
                    errors: errors,
                  },
                  on: { input: _vm.emit },
                  model: {
                    value: _vm.color4,
                    callback: function ($$v) {
                      _vm.color4 = $$v
                    },
                    expression: "color4",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("validation-provider", {
        attrs: { rules: "hex_color|required", slim: true, name: "color12" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("color-picker", {
                  attrs: {
                    name: "color12",
                    label: _vm.$t(
                      "theme.editor.colours.session_reg_checkmark_bg"
                    ),
                    errors: errors,
                  },
                  on: { input: _vm.emit },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "inside-label",
                        fn: function (ref) {
                          return [
                            _c("badge", { staticClass: "info" }, [
                              _vm._v(
                                _vm._s(_vm.$t("theme.editor.mobile_only"))
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.color12,
                    callback: function ($$v) {
                      _vm.color12 = $$v
                    },
                    expression: "color12",
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/theme/SimplifiedColorsForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__